export default {
  SLS_PASSWORD_LOGIN: "SLS_PASSWORD_LOGIN",
  SLS_OTP_LOGIN: "SLS_OTP_LOGIN",
  EDUPASS_LOGIN: "EDUPASS_LOGIN",
  NOT_LOGIN: "NOT_LOGIN",
};
